/** Representa um indicador de Cross Sell */
export interface CrossSell {
    id: number;
    nome: string;
    abreviacao: string;
    badge: string;
    icon: string;
}

/** Indicador sem cross sell */
export const crossSellSem: CrossSell = {
    id: 1,
    nome: 'SEM CROSS SELL',
    abreviacao: 'SEM',
    badge: 'badge badge-cross-sell-sem',
    icon: 'fas fa-times'
};

/** Indicador com cross sell */
export const crossSellCom: CrossSell = {
    id: 2,
    nome: 'COM CROSS SELL',
    abreviacao: 'COM',
    badge: 'badge badge-cross-sell-com',
    icon: 'fas fa-check'
};

/** Indicador com cross sell obrigatório */
export const crossSellObrigatorio: CrossSell = {
    id: 3,
    nome: 'CROSS SELL OBRIGATÓRIO',
    abreviacao: 'OBRIGATÓRIO',
    badge: 'badge badge-cross-sell-obrigatorio',
    icon: 'fas fa-star'
}

/** Indicadores de Cross Sell */
export const crossSells: CrossSell[] = [
    crossSellSem,
    crossSellCom,
    crossSellObrigatorio
];


/** Verifica se o indicador é sem Cross Sell */
export function isCrossSellSem(id: number): boolean {
    return id === crossSellSem.id;
}

/** Verifica se o indicador é com Cross Sell */
export function isCrossSell(id: number): boolean {
    return id === crossSellCom.id;
}

/** Verifica se o indicador é Cross Sell obrigatório */
export function isCrossSelObrigatorio(id: number): boolean {
    return id === crossSellObrigatorio.id;
}
